import dayjs from "dayjs";

export const formatDate = (d) => {
	const date = dayjs(d);
	if (date.isValid()) return date.format("DD-MM-YYYY HH:mm");
	else return "";
};
